import { Box, Container, Toolbar, useMediaQuery } from '@mui/material'
import RTKQueryPrefetcher from 'components/common/RTKQueryPrefetcher'
import { useTheme } from '@mui/material/styles'
import { routeEmptyStateConfig } from 'components/common/routeEmptyStateConfig'
import withRouteEmptyState from 'components/common/withRouteEmptyState'
import { DRAWER_WIDTH, MenuOrientation } from 'config'
import useConfig from 'hooks/useConfig'
import { useEffect } from 'react'
import { dispatch } from 'store'
import { openDrawer } from 'store/reducers/menu'
import Drawer from './Drawer'
import HorizontalBar from './Drawer/HorizontalBar'
import Header from './Header'

const MainLayout = () => {
  const theme = useTheme()
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'))
  const downLG = useMediaQuery(theme.breakpoints.down('lg'))

  const { miniDrawer, menuOrientation } = useConfig()

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      dispatch(openDrawer(!matchDownXL))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL])

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <RTKQueryPrefetcher />
      <Header />
      {!isHorizontal ? <Drawer /> : <HorizontalBar />}
      <Box
        component="main"
        sx={{
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          flexGrow: 1,
          px: { xs: '16px' },
          pb: { xs: '16px' },
        }}
      >
        <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
        <Container
          sx={{
            maxWidth: 'none !important',
            position: 'relative',
            px: { xs: '0' },
            pb: { xs: '0' },
            marginTop: { xs: '12px' },
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <OutletWithEmptyStates />
        </Container>
      </Box>
    </Box>
  )
}

const OutletWithEmptyStates = withRouteEmptyState(routeEmptyStateConfig)

export default MainLayout
